<template>
  <div class="sw-model-material-analyzing-model
      sw--position-relative
      sw--overflow-hidden
      sw-grid-flex
      sw-grid-flex--align-center
      sw--padding-hor-4
      sw-dms--bg-grey-96
      sw--border-transparent-1
      sw--border-radius-3
      sw--margin-bottom-1">
    <div class="sw-grid-flex sw-grid-flex--align-center sw-grid-flex__cell">
      <div class="sw-grid-flex__cell sw--position-relative sw-dms--color-grey-46 sw--margin-left-2">
        <div class="sw-model-material-analyzing-model__message-0">Analyzing 3D model</div>
        <div class="sw-model-material-analyzing-model__message-1
            sw--position-absolute
            sw--vertical-center
            sw--opacity-0">
          Fixing your model for printing…
        </div>
        <div class="sw-model-material-analyzing-model__message-2
            sw--position-absolute
            sw--vertical-center
            sw--opacity-0">
          Your model is taking some extra time to fix…
        </div>
        <div
          class="sw-model-material-analyzing-model__message-3
          sw--position-absolute
          sw--vertical-center
          sw--opacity-0">
          Bear with us! Due to complexities in your model, it may take several more minutes to finalize...
        </div>
      </div>
    </div>
    <div class="sw-model-material-analyzing-model__animation-bar
      sw--position-absolute
      sw--position-left
      sw--position-bottom
      sw--border-radius-2"></div>
  </div>

</template>

<script>
  export default {
    name: 'model-fix-analyzing-model'
  }
</script>
